import { useCallback } from "react";
import { useQueryClient, QueryKey } from "@tanstack/react-query";
import { useNavigate, useLocation } from "react-router";

import { General } from "capitalrx-components-2.0";
import { useModulePathResolver } from "capitalrx-shell";

interface SuccessHandlerOptions {
  message?: string;
  invalidations?: QueryKey;
  redirect?: string;
}

export function useSuccessHandler(): (options: SuccessHandlerOptions) => void {
  const showAlert = General.useAlert();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const resolvePath = useModulePathResolver();
  const location = useLocation();

  return useCallback(
    (options: SuccessHandlerOptions): void => {
      const { message, invalidations, redirect } = options;

      invalidations.forEach((invalidationTarget) => {
        queryClient.invalidateQueries({ queryKey: [invalidationTarget] });
      });

      if (redirect !== undefined && redirect !== null) {
        navigate(resolvePath(redirect), {
          state: {
            alert: {
              message,
              type: "success",
              style: "banner",
            },
          },
        });
      } else {
        // if there's a message show the alert
        message
          && showAlert({
            message,
            type: "success",
            style: "banner",
          });
      }


    },
    [location, queryClient, resolvePath, showAlert],
  );
}
